export default __webpack_public_path__ + "static/media/Array-SumVals.18560995.svg";